export const PRICING_LINK = "https://app.loadconnect.io/pricing";
